module.exports = __webpack_public_path__ + "static/Faerie_Dragon-0630f7f443e0a87d0e4e57776859fa38.jpg";